import React, { FC, useMemo, useRef } from 'react';
import { Ship } from '../../../../components/Ship';
import { useFrame } from '@react-three/fiber';
import { ShipEntity } from './game';
import { ShipConfig, Vector } from '../../../../types';
import { Color } from 'three';
import { repeat } from '../../../../utils';
import { randVector } from './ControlledGlyph';

export type ControlledShipProps = {
  shipEntity: ShipEntity;
  shipConfig: ShipConfig;
  position: Vector;
};

export const ControlledShip: FC<ControlledShipProps> = ({
  shipEntity,
  position,
  shipConfig,
}) => {
  const groupRef = useRef<any>();
  useFrame(() => {
    if (groupRef.current) {
      const {
        position: [x, y, z],
        velocity: [vx],
      } = shipEntity;
      groupRef.current.position.x = x;
      groupRef.current.position.y = y;
      groupRef.current.position.z = z;
      groupRef.current.rotation.y = vx / 12;
    }

    if (shipEntity.dead) {
    }
  });

  const updateMeshRef = (current: any) => {
    if (shipEntity.emissiveColor && !shipEntity.blastOff) {
      current.emissive = new Color(shipEntity.emissiveColor);
    } else if (!shipEntity.emissiveColor) {
      current.emissive = new Color('rgb(0,0,0)');
    }
  };

  const directions = useMemo(() => repeat(100, randVector), []);
  const rotations = useMemo(() => repeat(100, randVector), []);

  const updatePositionRef = (current: any, delta: number) => {
    if (shipEntity.dead && current) {
      const direction =
        directions[Math.floor(Math.random() * directions.length)];
      const rotation = rotations[Math.floor(Math.random() * directions.length)];
      current.position.x += direction[0] * delta;
      current.position.y += direction[1] * delta;
      current.position.z += direction[2] * delta;
      current.rotation.x += rotation[0] * delta;
      current.rotation.y += rotation[1] * delta;
      current.rotation.z += rotation[2] * delta;
    }
  };

  return (
    <Ship
      shipConfig={shipConfig}
      updateMeshRef={updateMeshRef}
      updatePositionRef={updatePositionRef}
      groupRef={el => (groupRef.current = el)}
      position={position}
    />
  );
};
